
import { createSlice } from '@reduxjs/toolkit'
import { ContainerApi } from '../api/DataApi'
import { AirportMaster,CommudityMaster,IMOMaster,UNMaster,companyList,services,Insertservices } from '../api/DataApi'
const initialState = {
    containerlist: [],
    airportMaster:[],
    portMaster:[],
    commudityMaster:[],
    unMaster:[],
    imoMaster:[],
    Services :[],
    CompanyList:[],
    insertservices:[],
    loading:false,
}

export const DataSlice = createSlice({
  name: 'DataSlice',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {

   
      builder.addCase(ContainerApi.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(ContainerApi.fulfilled , (state, action) => {
       
        state.containerlist=action.payload.data.data;
        
        state.loading = false;
      })
      builder.addCase(ContainerApi.rejected, (state, action) => {
        state.loading = false;
      
      })

      builder.addCase(AirportMaster.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(AirportMaster.fulfilled , (state, action) => {
       
        state.airportMaster=action.payload.data;
        state.portMaster=action.payload.portMaster;

      
        state.loading = false;
      })
      builder.addCase(AirportMaster.rejected, (state, action) => {
        state.loading = false;
      
      })




      builder.addCase(CommudityMaster.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(CommudityMaster.fulfilled , (state, action) => {
       
        state.commudityMaster=action.payload.data.data;
      
        state.loading = false;
      })
      builder.addCase(CommudityMaster.rejected, (state, action) => {
        state.loading = false;
      
      })
    
      builder.addCase(IMOMaster.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(IMOMaster.fulfilled , (state, action) => {
       
        state.imoMaster=action.payload.data.data;
      
        state.loading = false;
      })
      builder.addCase(IMOMaster.rejected, (state, action) => {
        state.loading = false;
      
      })
    
      builder.addCase(UNMaster.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(UNMaster.fulfilled , (state, action) => {
       
        state.unMaster=action.payload.data.data;
      
        state.loading = false;
      })
      builder.addCase(UNMaster.rejected, (state, action) => {
        state.loading = false;
      
      })
      builder.addCase(companyList.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(companyList.fulfilled , (state, action) => {
       
        state.CompanyList=action.payload.data.data;
      
        state.loading = false;
      })
      builder.addCase(companyList.rejected, (state, action) => {
        state.loading = false;
      
      })

      builder.addCase(services.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(services.fulfilled , (state, action) => {
       
        state.Services=action.payload.data.result;
      
        state.loading = false;
      })
      builder.addCase(services.rejected, (state, action) => {
        state.loading = false;
      
      })


      builder.addCase(Insertservices.pending, (state, action) => {
        state.loading = true;

      })
      builder.addCase(Insertservices.fulfilled , (state, action) => {
       
        state.insertservices=action.payload;
      
        state.loading = false;
      })
      builder.addCase(Insertservices.rejected, (state, action) => {
        state.loading = false;
      
      })
  },
 
})



export default DataSlice.reducer